

export default {
  name: "HappyKKidsDisclaimer",
  props: {
    data: {
        type: Object,
        default: () => {},
    },
    containerClass: {
      type: String,
      default: '',
    }
  },
  computed: {
    getContainerClass() {
      return this.containerClass;
    }
  }
};
